import { useContext as t } from "react";
import { GlobalNavContext as e } from "./GlobalNavv2Context.mjs";
const a = () => {
  const o = t(e);
  if (!o)
    throw new Error("useGlobalNavContext must be used within a GlobalNavv2 component.");
  return o;
};
export {
  a as useGlobalNavContext
};
